import script from "./segment-selector.vue?vue&type=script&setup=true&lang=ts"
export * from "./segment-selector.vue?vue&type=script&setup=true&lang=ts"

import "./segment-selector.vue?vue&type=style&index=0&id=35663416&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35663416"]])

export default __exports__